import { render, staticRenderFns } from "./accessmanagementlog.vue?vue&type=template&id=12db6aaa&"
import script from "./accessmanagementlog.vue?vue&type=script&lang=js&"
export * from "./accessmanagementlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports